import { useGeolocationStore } from '@/stores/geolocation.store';

const GPS_TIMEOUT_MS = 5_000;

export function useMarkerLocation() {
  const geolocationStore = useGeolocationStore();

  async function getLocation(): Promise<{ lat: number; lng: number } | null> {
    const cached = geolocationStore.userLocation?.location ?? null;

    const coords = await Promise.race([
      geolocationStore.requestFreshPosition(),
      new Promise<null>((resolve) => setTimeout(() => resolve(null), GPS_TIMEOUT_MS)),
    ]);

    if (coords) {
      return { lat: coords.latitude, lng: coords.longitude };
    }

    return cached;
  }

  return { getLocation };
}
